<template>
  <div>
    <v-row class="bg-extra-light-grey px-6 px-md-12 px-lg-12 pt-4 pb-2">
      <v-col
        cols="6"
        md="3"
      >
        <div
          class="fs-14 fw-600 mb-2"
          style="text-transform: uppercase"
        >
          {{ $bct('Support') }}
        </div>

        <div
          id="report_link"
          class="fs-14 mb-2 hover-underlined"
          tracked
        >
          <a
            :href="getSupportURL()"
            target="_blank"
          >
            {{ $bct('Report an issue') }}
          </a>
        </div>

        <div
          id="submit_feedback_link"
          class="fs-14 mb-2 hover-underlined"
          tracked
        >
          <a
            :href="getFeedbackURL()"
            target="_blank"
          >
            {{ $bct('Submit feedback') }}
          </a>
        </div>

        <div
          id="support_contact_link"
          class="fs-14 mb-2 hover-underlined"
          tracked
        >
          <a :href="'mailto:' + ($store.state.site.parent_support_email || EMAILS.SUPPORT)">
            {{ $bct('Contact us') }}
          </a>
        </div>
      </v-col>

      <v-col
        cols="6"
        md="3"
      >
        <div v-if="$store.state.site.provider_root_url">
          <div
            class="fs-14 fw-600 mb-2"
            style="text-transform: uppercase"
          >
            {{ $bct('For providers') }}
          </div>

          <div
            id="update_link"
            class="fs-14 mb-2 hover-underlined"
            tracked
          >
            <a
              :href="$store.state.site.provider_root_url"
              target="_blank"
            >
              {{ $bct('Update your profile') }}
            </a>
          </div>

          <div
            id="provider_contact_link"
            class="fs-14 mb-2 hover-underlined"
            tracked
          >
            <a :href="getContactUsURL()">
              {{ $bct('Contact us') }}
            </a>
          </div>
        </div>
      </v-col>

      <v-col
        class="ta-right"
        cols="12"
        md="6"
      >
        <div
          class="fs-14 mb-1"
          style="text-transform: uppercase"
        >
          {{ $bct('Powered by') }}
        </div>

        <a
          id="parent_bridgecare_logo_link"
          href="https://www.getbridgecare.com"
          target="_blank"
          tracked
        >
          <img
            :alt="$bct('BridgeCare Homepage')"
            :src="$a.url('images.bridgecare_logo')"
            style="max-width: 170px"
          />
        </a>
      </v-col>

      <v-col
        class="ta-right"
        cols="12"
      >
        <a
          id="terms_link"
          class="fs-14 me-2 hover-underlined"
          href="https://www.getbridgecare.com/terms-of-service"
          target="_blank"
          tracked
        >
          {{ $bct('Terms of Service') }}
        </a>
        <span>|</span>
        <a
          id="privacy_link"
          class="ms-2 fs-14 hover-underlined"
          href="https://www.getbridgecare.com/privacy-policy"
          target="_blank"
          tracked
        >
          {{ $bct('Privacy Policy') }}
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';

import { EMAILS } from '@/shared/assets/constants';

const store = useStore();
const $bct = inject('translator');

function getContactUsURL() {
  const email = store.state.site.provider_support_email || EMAILS.SUPPORT;
  return 'mailto:' + email;
}

function getFeedbackURL() {
  const url = store.state.config.feedback_url;
  if (!url) return 'https://airtable.com/shrOPCN7sZRbl2uof';

  return getMailToOrURL(url);
}

function getSupportURL() {
  const email = store.state.site.parent_support_email;
  return email ? getMailToOrURL(email) : null;
}

function getMailToOrURL(url) {
  if (url.includes('@') && !url.includes('mailto')) {
    return `mailto:${url}`;
  }

  return url;
}
</script>
